// screens/.../Dashboard/Dashboard.jsx
import React, { useEffect, useState } from "react";
import Classes from "./Dashboard.module.css";
import Hero1 from "./Comp/Hero1";
import RecordTable from "./Comp/RecordTable/RecordTable";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import Hero2 from "./Comp/Hero2/Hero2";
import SuccessPopup from "../../../../GlobalComponents/SuccessPopup/SuccessPopup";

/** Read a path from window / parent / referrer safely */
function getPathsToCheck() {
  const paths = [];
  try {
    const p = window.location?.pathname;
    if (p) paths.push(p);
  } catch { }
  try {
    if (window.parent && window.parent !== window) {
      const pp = window.parent.location?.pathname;
      if (pp) paths.push(pp);
    }
  } catch {
    // cross-origin parent, ignore
  }
  try {
    if (document.referrer) {
      const ref = new URL(document.referrer);
      if (ref.pathname) paths.push(ref.pathname);
    }
  } catch { }
  return paths;
}

/** Detect flow + status from any known path */
function detectRouteStatus() {
  const paths = getPathsToCheck();
  const has = (frag) => paths.some((p) => p.includes(frag));

  // Payment (appointments)
  if (has("/payment/success")) return { flow: "payment", status: "success" };
  if (has("/payment/cancelled")) return { flow: "payment", status: "cancelled" };

  // Subscription (membership)
  if (has("/subscription/success")) return { flow: "subscription", status: "success" };
  if (has("/subscription/cancelled")) return { flow: "subscription", status: "cancelled" };

  return { flow: null, status: null };
}

/** Map flow+status → popup content */
function popupContent(flow, status) {
  if (flow === "payment" && status === "success") {
    return {
      title: "Appointment Confirmed",
      message:
        "Your Fuel Clubs appointment has been successfully scheduled. A receipt was sent to your email. You can continue to your dashboard anytime.",
    };
  }
  if (flow === "payment" && status === "cancelled") {
    return {
      title: "Checkout Cancelled",
      message:
        "Your checkout was cancelled. No charges were made. You can try again from your dashboard when ready.",
    };
  }
  if (flow === "subscription" && status === "success") {
    return {
      title: "Membership Activated",
      message:
        "Your Fuel Clubs membership is active. You now enjoy member benefits on eligible services.",
    };
  }
  if (flow === "subscription" && status === "cancelled") {
    return {
      title: "Subscription Checkout Cancelled",
      message:
        "Your subscription checkout was cancelled. No charges were made. You can subscribe anytime from your dashboard.",
    };
  }
  return null;
}

export default function Dashboard() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const location = useLocation();

  // Keep support for existing query params (?appt=success|cancelled)
  const apptStatus = searchParams.get("appt");

  const [popup, setPopup] = useState(null); // { title, message } | null

  useEffect(() => {
    const route = detectRouteStatus();

    // Priority: explicit query param (back-compat), then detected route/referrer/parent
    if (apptStatus === "success" || apptStatus === "cancelled") {
      const pc = popupContent("payment", apptStatus);
      setPopup(pc);
      return;
    }

    if (route.flow && route.status) {
      const pc = popupContent(route.flow, route.status);
      setPopup(pc);
      return;
    }

    setPopup(null);
  }, [apptStatus, location.key]);

  const clearParamsAndNormalize = () => {
    navigate({ pathname: "/", search: "" }, { replace: true });
  };

  return (
    <>
      <div className={Classes.hero}>
        <Hero1 />
        <Hero2 />
        <RecordTable />
      </div>

      {popup && (
        <SuccessPopup
          title={popup.title}
          message={popup.message}
          onClose={() => {
            setPopup(null);
            clearParamsAndNormalize();
          }}
        />
      )}
    </>
  );
}
